import { Badge } from "../../../../components/Badge/Badge";
import { ArrowIcon, MoneyIcon } from "../../../../components/icons";

export interface IBadgesProps {
  badgesData: {
    value: string;
    rightItems?: string[];
  }[];
  isLoading: boolean;
}

const Badges: React.FC<IBadgesProps> = ({ badgesData, isLoading }) => {
  return (
    <div className="badges-container">
      <div className="row gy-5 g-xl-5 row-plex">
        <div className="col-md-4 col-lg-4 col-xl-4 col-xxl-4 mb-xl-0">
          <Badge
            variant="primary"
            content={{
              tooltipText:
                "The total costs for all the models for the selected period.",
              value: isLoading ? "" : badgesData[0].value,
              title: "Total costs",
              rightItems: [
                {
                  beforeIcon: (
                    <>
                      <MoneyIcon />
                      <ArrowIcon className="arrow" size={8} />
                    </>
                  ),
                  text: badgesData[0].rightItems && badgesData[0].rightItems[0],
                  subtitle: "costs savings",
                },
              ],
            }}
          />
        </div>
        <div className="col-md-4 col-lg-4 col-xl-4 col-xxl-4 mb-xl-0">
          <Badge
            variant="info"
            content={{
              tooltipText:
                "Total amount of tokens consumed for the selected period. The tokens that are generated from cache are free of charge.",
              value: isLoading ? "" : badgesData[1].value,
              title: "Total tokens",
              rightItems: [
                {
                  text: badgesData[1].rightItems && badgesData[1].rightItems[0],
                  subtitle: "paid tokens",
                },
                {
                  text: badgesData[1].rightItems && badgesData[1].rightItems[1],
                  subtitle: "free tokens",
                },
              ],
            }}
          />
        </div>
        <div className="col-md-4 col-lg-4 col-xl-4 col-xxl-4 mb-xl-0">
          <Badge
            variant="primary"
            content={{
              tooltipText:
                "The percentage of answers coming from the cache. The higher the number, the better.",
              value: isLoading ? "" : badgesData[2].value,
              title: "Cache hit ratio",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export { Badges };
